import { Store } from './contentStore'

export const contentStoreSingleton: { contentStore: Store | null } = {
  contentStore: null,
}
export function getContentStore() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return contentStoreSingleton.contentStore
}
